// extracted by mini-css-extract-plugin
export default {"collectionDetails":"CollectionResult_collectionDetails__F-6Ef"};